/** 장조 차용 1도 단3화음 2전위: i + (b6)/4 피겨 — b는 6음의 내림을 뜻함 */
export const CHORD_SYMBOL_I_MODE_MIX_B64 = 'ib\u2076\u2084'

/** 이전 버전(♭ 기호); 캐시·구 응답 호환 */
const LEGACY_CHORD_SYMBOL_I_MODE_MIX_FLAT64 = 'i\u266d\u2076\u2084'

export function isChordSymbolIB64Figure(sym) {
  const s = String(sym)
  return s === CHORD_SYMBOL_I_MODE_MIX_B64 || s === LEGACY_CHORD_SYMBOL_I_MODE_MIX_FLAT64
}
